import { t } from '@lingui/core/macro';
import { EmptyState } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { DocumentPageContainer } from '../../styled';
import { EmptyContainer } from './styled';
// Note: This is done in order to not get TSC errors further up in the component tree.
// We get that because we always pass the document to the preview component.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function BasePreview(props) {
    const title = t({
        message: 'Unsupported document type',
        comment: 'document preview unsupported document type title',
    });
    const subtitle = t({
        message: 'We do not currently support previewing documents of this file type.',
        comment: 'document preview unsupported document type subtitle',
    });
    return (<DocumentPageContainer>
      <EmptyContainer>
        <EmptyState icon={<Falcon icon="eye-slash"/>} title={title} description={subtitle}/>
      </EmptyContainer>
    </DocumentPageContainer>);
}
